/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ScheduleAppointment/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2CalendarScheduleAppointment from 'DesignSystem/Svgs/Tysiav2CalendarScheduleAppointment/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ScheduleAppointment({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay/ActionsPopover/ScheduleAppointment"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="ScheduleAppointment.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-2uQ4Ak': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2CalendarScheduleAppointment
  viewPath={`${viewPath}/Tysiav2CalendarScheduleAppointment`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill2={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Schedule an appointment"
 color={dtColorsNeutral900}
 marginLeft={dtSpaceXs}
/>
</div>
{children}
</React.Fragment>)
}